function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 2",
  width: 10.629,
  height: 1.597,
  rx: 0.798,
  transform: "rotate(106.68 25.279 20.427)",
  fill: "#fbbb34"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1",
  d: "M11.59 3.381v1.668a.978.978 0 00.98.98h3.188a.98.98 0 01.98.98v.1a.978.978 0 01-.98.98h-3.189a.98.98 0 00-.98.984v3.483a.98.98 0 01-.98.98.98.98 0 01-.98-.98V1.305a.978.978 0 01.986-.98h5.711a1.037 1.037 0 011.039 1.041 1.039 1.039 0 01-1.039 1.033h-3.75a.978.978 0 00-.986.982z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M23.278 9.825l2.4-8.76a1.007 1.007 0 01.973-.742h.213a1.007 1.007 0 01.973.742l2.4 8.76 2.7-8.79a1.007 1.007 0 01.973-.712 1.007 1.007 0 01.965 1.3l-3.383 11a1.29 1.29 0 01-1.233.912 1.292 1.292 0 01-1.237-.965l-2.183-8.1h-.134l-2.183 8.1a1.292 1.292 0 01-1.245.954 1.29 1.29 0 01-1.245-.9l-3.373-11a1.007 1.007 0 01.965-1.3 1.007 1.007 0 01.954.713z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M39.829 2.063a2.338 2.338 0 00-1.4.4 1.386 1.386 0 00-.548 1.2 1.462 1.462 0 00.548 1.228 7.663 7.663 0 002.338.916 6.042 6.042 0 012.689 1.379 3.5 3.5 0 01.905 2.616 3.677 3.677 0 01-1.146 2.805 4.2 4.2 0 01-3.005 1.078 6.4 6.4 0 01-4.136-1.5.993.993 0 01-.166-1.358l.055-.077a1 1 0 011.415-.213 4.712 4.712 0 002.88 1.063 2.266 2.266 0 001.5-.453 1.515 1.515 0 00.557-1.228 1.449 1.449 0 00-.523-1.19 5.115 5.115 0 00-1.8-.774 15.124 15.124 0 01-1.943-.638 4.291 4.291 0 01-1.18-.767 3.4 3.4 0 01-1.04-2.721A3.494 3.494 0 0137 1.004a4.325 4.325 0 012.9-1 6.2 6.2 0 012.209.425 5.815 5.815 0 011.12.563 1 1 0 01.3 1.369 1.012 1.012 0 01-1.358.334 5.227 5.227 0 00-.616-.289 4.793 4.793 0 00-1.73-.34z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M1.893 6.934l3.431-3.432a.784.784 0 000-1.109.784.784 0 00-1.109 0L.229 6.382a.784.784 0 000 1.109l3.986 3.986a.784.784 0 001.109 0 .786.786 0 000-1.111z",
  fill: "#56d2f7"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5",
  d: "M57.157 6.934l-3.43 3.43a.786.786 0 000 1.111.786.786 0 001.111 0l3.984-3.986a.784.784 0 000-1.109L54.837 2.4a.786.786 0 00-1.109 0 .784.784 0 000 1.109z",
  fill: "#56d2f7"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59.052 13.682",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.93844c2a.svg";
export { ForwardRef as ReactComponent };